import React, { Component } from 'react';
import { upload } from './PhotosRest';

export default class UploadFile extends Component {
    constructor(props) {
	super(props);
	this.uploadRef = React.createRef();
	this.uploadFile()
    }

    componentDidMount() {
	document.addEventListener('touchend', this.upload, false);
    }

    componentWillUnmount() {
	document.removeEventListener('touchend', this.upload, false);
    }

    uploadFile = () => upload(this.props.file, this.props.set, this.props.access, this.uploadRef.current, this.props.callback);

    render() {
	return (
	    <div className='upload'>
	    <div className='file' onClick={this.uploadFile}>
	      <span className='remove' onClick={() => this.props.remove(this.props.file)}>
	      X
	      </span>
	      { this.props.file.name }
	    </div>
	    <progress ref={this.uploadRef} className='upload' max='100' value='0'/>
	    </div>
	)
    }
}
